import { RubberStampPreview, RubberStampResult, type Canvas } from "./Classes";
import type { IOptions } from "./Interfaces";
import { layouts, delay, image, options, rs_product, rs_product_no_result, rs_product_too_large } from "./TestVars"

// todo: Could reduce boilerplate code 
export default class APIClient {

    private fakeAPI: boolean = false;
    private fakeDelay: boolean = false;
    private base: string;

    constructor(base: string) {
        this.base = base;
    }

    public async fetchPreview(canvas: Canvas): Promise<string> {
        if (this.fakeDelay) await delay(1000);
        if (this.fakeAPI) return image;
        const response = await fetch(
            this.base + "/api/Preview",
            {
                method: "POST",
                body: JSON.stringify(canvas),
                headers: {
                    "Content-Type": "application/json",
                },
            });
        const result = await response.text();
        if (response.ok) {
            return result;
        } else {
            throw response.statusText;
        }
    }

    public async fetchRubberStampPreview(canvas: Canvas): Promise<RubberStampPreview> {
        if (this.fakeDelay) await delay(1000);
        if (this.fakeAPI) return new RubberStampPreview(image, 100, 100);
        const response = await fetch(
            this.base + "/api/Preview",
            {
                method: "POST",
                body: JSON.stringify(canvas),
                headers: {
                    "Content-Type": "application/json",
                },
            });
        const result = await response.json();
        if (response.ok) {
            return result;
        } else {
            throw response.statusText;
        }
    }

    public async SearchBestMatchRubberStamp(width: number, height: number, inkingTypeName: string): Promise<RubberStampResult> {
        if (this.fakeDelay) await delay(1000);
        // if (this.fakeAPI) return JSON.parse(rs_product);
        // if (true) return JSON.parse(rs_product);
        // if (true) return JSON.parse(rs_product_no_result);
        // if (true) return JSON.parse(rs_product_too_large);
        const response = await fetch(
            // 'https://localhost:44368' +
            `/Products/SearchBestMatchRubberStamp?width=${width}&height=${height}&inkingTypeName=${inkingTypeName}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            });
        const result = await response.json();
        if (response.ok) {
            return result;
        } else {
            throw response.statusText;
        }
    }

    public async fetchLayout(layoutId: string): Promise<Canvas> {
        if (this.fakeDelay) await delay(1000);
        if (this.fakeAPI) return JSON.parse(layouts);
        const response = await fetch(
            this.base + "/api/Preview/GetLayout/" + layoutId,
            {
                method: "GET",
            }
        );
        const result = await response.json();
        if (response.ok) {
            return result;
        } else {
            throw response.statusText;
        }
    }

    public async fetchOptions(productId: string): Promise<IOptions> {
        if (this.fakeDelay) await delay(1000);
        if (this.fakeAPI) return JSON.parse(options);
        const response = await fetch(
            this.base + "/api/Preview/GetOptions/" + productId,
            {
                method: "GET",
            }
        );
        const result = await response.json();
        if (response.ok) {
            return result;
        } else {
            throw response.statusText;
        }
    }

    public async fetchThumbnail(imageId: string): Promise<string> {
        // if (this.fakeDelay) await delay(1000);
        // if (this.fakeAPI) return JSON.parse(options);
        const response = await fetch(
            this.base + "/api/Media/Thumb/" + imageId,
            {
                method: "GET",
            }
        );
        const result = await response.text();
        if (response.ok) {
            return result;
        } else {
            throw response.statusText;
        }
    }

    public async uploadFiles(canvasWidth: number, canvasHeight: number, formData: FormData,
        loadstartHandler: (lengthComputable: boolean, total: number) => void,
        progressHandler: (lengthComputable: boolean, loaded: number, total: number) => void,
        abortEvent: (abort: () => void) => void,
        abortHandler: (type: string) => void): Promise<string[]> {
        // if (this.fakeDelay) await delay(1000);
        // if (this.fakeAPI) return JSON.parse(options);
        return await this.ajaxRequest("POST", `${this.base}/api/Media/Upload/${canvasWidth}x${canvasHeight}/`, formData, "json", loadstartHandler, progressHandler, abortEvent, abortHandler);
    }

    private async ajaxRequest(requestMethod: string, requestUrl: string, formData: FormData, responseType: XMLHttpRequestResponseType,
        loadstartHandler: (lengthComputable: boolean, total: number) => void,
        progressHandler: (lengthComputable: boolean, loaded: number, total: number) => void,
        abortEvent: (abort: () => void) => void,
        abortHandler: (eventType: string) => void): Promise<any> {

        return new Promise((resolve, reject) => {

            var xhr = new XMLHttpRequest();

            // The upload has begun.
            loadstartHandler && xhr.upload.addEventListener("loadstart", (e) => loadstartHandler(e.lengthComputable, e.total));

            // Periodically delivered to indicate the amount of progress made so far.
            progressHandler && xhr.upload.addEventListener("progress", (e) => progressHandler(e.lengthComputable, e.loaded, e.total));

            // The upload operation was aborted.
            abortHandler && xhr.upload.addEventListener("abort", (e) => abortHandler(e.type));

            // The upload failed due to an error.
            // xhr.upload.addEventListener("error", errorHandler);

            // The upload timed out because a reply did not arrive within the time interval specified by the XMLHttpRequest.timeout.
            // xhr.upload.addEventListener("timeout", timeoutHandler)

            // The upload completed successfully.
            // xhr.upload.addEventListener("load", loadHandler);

            // Pass the abort method to the callback function
            abortEvent && abortEvent(() => xhr.abort());

            xhr.open(requestMethod, requestUrl);
            xhr.responseType = responseType;

            xhr.onload = () => {
                if (xhr.status === 0 || (xhr.status >= 200 && xhr.status < 400)) {
                    resolve(xhr.response);
                } else {
                    reject(xhr.statusText);
                }
            };

            xhr.onerror = () => reject(xhr.statusText);

            xhr.send(formData);
        });
    }
}